/**
 * Which menu rows an account sees (المرحلة 1.1), without React.
 */

import { centerOpen } from './centerPolicy';

/**
 * Drop the rows this account lacks the capability for (`needs`, `needsAny`),
 * and — for a manager on a ready-made admin role — the desks outside it
 * (`roleNeeds`). A row marked `roleOnly` is one of those roles' own screens
 * (the finance role's revenue, compliance's log): a manager on no named role
 * does not see it, so their menu is the one it was before the phase. Before
 * the capabilities arrive (`loading`, or `ready === false`) nothing is
 * dropped, so the menu does not flicker; a heading left with nothing under it
 * goes too.
 *
 * `center` (المرحلة 1.35) names one of the medical centre's policies the row
 * needs on (locale.center, domain/centerPolicy.js): the price list is in the
 * menu only where the Super Admin opened it. Those rows are off by default,
 * so they wait for the answer rather than show and vanish.
 */
export function permittedNavItems(items, { can, canAny, adminRole, loading, ready, locale }) {
  if (loading || ready === false) return items.some((item) => item.center) ? items.filter((item) => !item.center) : items;
  const kept = items.filter((item) => {
    if (item.section) return true;
    if (item.center && !centerOpen(locale, item.center)) return false;
    if (item.roleOnly && !adminRole) return false;
    if (item.needs && !can(item.needs)) return false;
    if (item.needsAny && !canAny(item.needsAny)) return false;
    if (adminRole && item.roleNeeds && !can(item.roleNeeds)) return false;
    return true;
  });
  return kept.filter((item, i) => !item.section || (kept[i + 1] && !kept[i + 1].section));
}
